import {
  TOGGLE_SIDE_MENU,
} from '../actions/constants';

export const toggleSideMenu = () => {
  return {
    type: TOGGLE_SIDE_MENU,
  };
};
